<template>
  <div v-if="loaded===true">
    <div class="row box">
      <div class="col-12">
        <div class="row mt-2 topbox">
          <div class="col-10">
            <b class="mt-1" id="privileges">Privileges</b>
          </div>
          <div class="col-2 text-right">
            <button class="btn-transparent" v-show="isadmin===true&&!isDisabled" @click="doEditPrivileges"><font-awesome-icon icon="edit" aria-label="Edit Privileges" style="color:white!important;"></font-awesome-icon></button>
          </div>
        </div>
        <div class="row botbox">
          <div class="col-12">
            <div class="row" v-if="privileges.length>0" v-for="privilege in privileges">
              <div class="col-12">
                {{privilege.Rendered}}
              </div>
            </div>
            <div class="row" v-if="privileges.length===0">
              <div class="col-12" id="member_does_not_have_privileges">
                This member does not have any privileges for this pool
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row box">
      <div class="col-12">
        <div class="row mt-3 topbox">
          <div class="col-10">
            <b class="mt-1" id="groups">Groups</b>
          </div>
          <div class="col-2 text-right">
            <button class="btn-transparent" v-show="isadmin===true" @click="doAdd('groups')"><font-awesome-icon icon="plus" aria-label="Add Groups" style="color:white!important;"></font-awesome-icon></button>
          </div>
        </div>
        <div class="row botbox">
          <div class="col-12">
            <div class="row" v-if="groups.length>0" v-for="group in groups">
              <div class="col-11">
                <router-link :to="{name:'groupdash', params:{id:group.LicensePoolGroupID}}" v-html="group.LicensePoolGroupName"></router-link>
              </div>
              <div class="col-1 text-right">
                <button class="btn-transparent" v-show="isadmin===true&&group.ParentID!='00000000-0000-0000-0000-000000000000'" @click="doRemoveGroup(group.LicensePoolGroupID)"><font-awesome-icon icon="times" aria-label="Remove Group"></font-awesome-icon></button>
              </div>
            </div>
            <div class="row" v-if="groups.length===0">
              <div class="col-12" id="member_does_not_belong_groups">
                This member does not belong to any groups in this pool
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row box">
      <div class="col-12">
        <div class="row mt-3 topbox">
          <div class="col-10">
            <b class="mt-1" id="products">Products</b>
          </div>
          <div class="col-2 text-right">
            <button class="btn-transparent" v-show="isadmin===true&&!isDisabled" @click="doAdd('products')"><font-awesome-icon icon="plus" aria-label="Add Products" style="color:white!important;"></font-awesome-icon></button>
          </div>
        </div>
        <div class="row botbox">
          <div class="col-12">
            <div class="row" v-if="products.filter(p=>p.LicensePoolProductID!==null).length>0" v-for="product in products.filter(p=>p.LicensePoolProductID!==null)">
              <div class="col-10" v-html="product.ProductName">

              </div>
              <div class="col-1 text-center">
                <button class="btn-transparent" @click="doLicensePopup(product)" v-show="!isDisabled"><font-awesome-icon icon="info-circle" aria-label="Product License Info"></font-awesome-icon></button>
              </div>
              <div class="col-1 text-center">
                <button class="btn-transparent" v-show="isadmin===true&&!isDisabled" @click="doRemoveProduct(product.LicensePoolProductID)"><font-awesome-icon icon="times" aria-label="Remove Product"></font-awesome-icon></button>
              </div>
            </div>
            <div class="row" v-if="products.filter(p=>p.LicensePoolProductID!==null).length===0">
              <div class="col-12" id="member_does_not_have_products">
                This member does not have any products in this pool
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row box">
      <div class="col-12">
        <div class="row mt-3 topbox">
          <div class="col-10">
            <b class="mt-1" id="bundles">Bundles</b>
          </div>
          <div class="col-2 text-right">
            <button class="btn-transparent" v-show="isadmin===true&&!isDisabled" @click="doAdd('bundles')"><font-awesome-icon icon="plus" aria-label="Add Bundles" style="color:white!important;"></font-awesome-icon></button>
          </div>
        </div>
        <div class="row botbox">
          <div class="col-12">
            <div class="row" v-if="bundles.length>0" v-for="bundle in bundles">
              <div class="col-12">
                <div class="row">
                  <div class="col-11" v-html="bundle.BundleName">

                  </div>
                  <div class="col-1 text-right">
                    <button class="btn-transparent" v-show="isadmin===true" @click="doRemoveBundle(bundle.BundleID)"><font-awesome-icon icon="times" aria-label="Remove Bundle"></font-awesome-icon></button>
                  </div>
                </div>
                <div class="row" v-for="bp in bundleproducts.filter(p=>p.BundleID===bundle.BundleID)">
                  <div class="col-12">
                    <div class="ml-5">{{bp.ProductName}}</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row" v-if="bundles.length===0">
              <div class="col-12" id="member_does_not_have_bundles">
                This member does not have any bundles in this pool
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row box">
      <div class="col-12">
        <div class="row mt-3 topbox">
          <div class="col-10">
            <b class="mt-1" id="training_plans">Training Plans</b>
          </div>
          <div class="col-2 text-right">
            <button class="btn-transparent" v-show="isadmin===true&&!isDisabled" @click="doAdd('trainingplans')"><font-awesome-icon icon="plus" aria-label="Add Bundles" style="color:white!important;"></font-awesome-icon></button>
          </div>
        </div>
        <div class="row botbox">
          <div class="col-12">
            <div class="row" v-if="trainingplans.length>0" v-for="plan in trainingplans">
              <div class="col-11" v-html="plan.CurriculumName">

              </div>
              <div class="col-1 text-right">
                <button class="btn-transparent" v-show="isadmin===true" @click="doRemoveTrainingPlan(plan.CurriculaID)"><font-awesome-icon icon="times" aria-label="Remove Training Plan"></font-awesome-icon></button>
              </div>
            </div>
            <div class="row" v-if="trainingplans.length===0">
              <div class="col-12" id="member_does_not_have_training_plans">
                This member does not have any training plans in this pool
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <privmodule ref="privPlugin" :poolID="pool.LicensePoolID" :allowPool="true"></privmodule>
    <b-modal title="License Information" size="lg" ref="licPopup" ok-only>
      <div class="row">
        <div class="col-6">
          License Type:
        </div>
        <div class="col-6 text-right">
          {{lictype}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          Expiration Date:
        </div>
        <div class="col-6 text-right">
          {{expdate}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          Time Remaining:
        </div>
        <div class="col-6 text-right">
          {{timeremaining}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          Date Assigned:
        </div>
        <div class="col-6 text-right">
          {{dateassigned}}
        </div>
      </div>
    </b-modal>

  </div>
</template>

<style scoped>
  .box {
    margin-left: 1.5%;
    margin-right: 1.5%;
  }

  .botbox {
    border-bottom: 1px solid #666;
    border-left: 1px solid #666;
    border-right: 1px solid #666;
    padding: 2%;
  }

  .topbox {
    border: 1px solid #666;
    padding: 0.5%;
    background-color: #2A6693;
    color: #FFF;
  }
</style>

<script>
  import privmodule from "./Privileges.vue"

  export default {
    name: "ClientPoolDetail",
    props: ["pool", "isadmin", "name", "groupscope", "groupid"],
    components: { privmodule },
    data() {
      return {
        loaded: false,
        privileges: [],
        products: [],
        bundles: [],
        bundleproducts: [],
        groups: [],
        trainingplans: [],
        user: null,
        userprivs: [],
        lictype: null,
        expdate: null,
        dateassigned: null,
        timeremaining: null
      }
    },
    methods: {
      assGroupComplete() {

      },
      doAdd(p) {
        var su = {
          Name: this.name,
          ClientID: this.pool.ClientID
        };
        localStorage.setItem("assigndata", JSON.stringify([su]));
        if (this.groupscope === false) {
          this.$router.push("/pool/" + this.pool.LicensePoolID + "/assign/" + p + "/do");
        }
        else {
          this.$router.push("/group/" + this.groupid + "/assign/" + p + "/do");
        }
      },
      doEditPrivileges() {
        this.apiCommand([{
          Operation: "LicensePool",
          Function: "GetGroups",
          Fields: {
            LicensePoolID: this.pool.LicensePoolID
          }
        }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.$refs["privPlugin"].groups = JSON.parse(cr.returnObjects[0].returnObject);
          this.$refs["privPlugin"].groups.unshift({
            LicensePoolGroupID: this.emptyguid,
            LicensePoolGroupName: "--- Select ---"
          });

          this.$refs["privPlugin"].users.push({
            Name: this.name,
            ClientID: this.pool.ClientID
          })

          this.$refs["privPlugin"].user = this.pool.ClientID;
          this.$refs["privPlugin"].$refs["aePrivileges"].show();
        });
      },
      doLicensePopup(cpdata) {

        switch (cpdata.LicenseType) {
          case 0: this.lictype = "Single-User"; break;
          case 1: this.lictype = "Hourly"; break;
          case 2: this.lictype = "Collaborator"; break;
          case 3: this.lictype = "Free with Expiration"; break;
          case 4: this.lictype = "Recurring"; break;
        }

        if (cpdata.LicenseType >= 3) {
          this.expdate = this.buildDateTime(cpdata.LicenseExpirationDate, false);
        }
        else {
          this.expdate = "N/A";
        }

        if (cpdata.LicenseType == 1) {
          this.timeremaining = cpdata.LicenseTimeRemaining + " Minutes";
        }
        else {
          this.timeremaining = "N/A";
        }

        if (cpdata.AssignmentDate !== null) {
          this.dateassigned = this.buildDateTime(cpdata.AssignmentDate, false);
        }
        else {
          this.dateassigned = "Unknown";
        }

        this.$refs["licPopup"].show();
      },
      doRemoveBundle(bundleID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this bundle from this user?', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "Client",
                Function: "UnassignBundle",
                Fields: {
                  BundleID: bundleID,
                  ClientID: this.pool.ClientID
                }
              }
            ]).then(r => {
              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject === "OK") {
                this.popDialog(0, "Bundle unassigned successfully");
                this.render();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }
            });
          }
        });
        setTimeout(Window.loadLanguageContent(), 500);
      },
      doRemoveGroup(groupID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this group from this user?', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteMemberGroup",
                Fields: {
                  LicensePoolID: this.pool.LicensePoolID,
                  GroupID: groupID,
                  ClientID: this.pool.ClientID
                }
              }
            ]).then(r => {
              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject === "OK") {
                this.popDialog(0, "Group unassigned successfully");
                this.render();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }
            });
          }
        });
        setTimeout(Window.loadLanguageContent(), 500);
      },
      doRemoveTrainingPlan(tpID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this training plan from this user?', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteMemberCurriculum",
                Fields: {
                  LicensePoolID: this.pool.LicensePoolID,
                  CurriculumID: tpID,
                  ClientID: this.pool.ClientID
                }
              }
            ]).then(r => {
              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject === "OK") {
                this.popDialog(0, "Training Plan unassigned successfully");
                this.render();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }
            });
          }
        });
        setTimeout(Window.loadLanguageContent(), 500);
      },
      doRemoveProduct(prID) {
        if (prID === null) {
          this.popDialog(1, "Cannot delete this product because it is part of a bundle");
          return;
        }

        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this product from this user?', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteMemberProduct",
                Fields: {
                  LicensePoolID: this.pool.LicensePoolID,
                  LicensePoolProductID: prID,
                  ClientID: this.pool.ClientID
                }
              }
            ]).then(r => {
              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject === "OK") {
                this.popDialog(0, "Product unassigned successfully");
                this.render();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }
            });
          }
        });
        setTimeout(Window.loadLanguageContent(), 500);
      },
      render() {
        this.loaded = false;
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetGroupsForUser",
            Fields: {
              LicensePoolID: this.pool.LicensePoolID,
              ClientID: this.pool.ClientID
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetCurriculaForUser",
            Fields: {
              LicensePoolID: this.pool.LicensePoolID,
              ClientID: this.pool.ClientID
            }
          },

          {
            Operation: "LicensePool",
            Function: "GetProductsForUser",
            Fields: {
              LicensePoolID: this.pool.LicensePoolID,
              ClientID: this.pool.ClientID,
              IncludeBundles: "false"
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetPrivilegesForUser",
            Fields: {
              LicensePoolID: this.pool.LicensePoolID,
              ClientID: this.pool.ClientID
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetBundlesForUser",
            Fields: {
              LicensePoolID: this.pool.LicensePoolID,
              ClientID: this.pool.ClientID
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.privileges = [];
          for (var privilege of JSON.parse(cr.returnObjects[3].returnObject)) {
            if (privilege.GroupID === this.emptyguid) {
              privilege.Rendered = privilege.AdminType + " For Pool";
            }
            else {
              privilege.Rendered = privilege.AdminType + " For Group " + privilege.GroupName;
            }
            this.privileges.push(privilege);
          }
          this.groups = JSON.parse(cr.returnObjects[0].returnObject);
          console.log(this.groups);
          this.trainingplans = JSON.parse(cr.returnObjects[1].returnObject);
          this.products = JSON.parse(cr.returnObjects[2].returnObject);

          console.log(this.products);

          var bdspl = cr.returnObjects[4].returnObject.split("||||");
          this.bundles = JSON.parse(bdspl[0]);
          this.bundleproducts = JSON.parse(bdspl[1]);

          this.loaded = true;

          setTimeout(Window.loadLanguageContent(), 500);
        });
      }
    },
    mounted() {
      this.render();
    },
    computed: {
      isDisabled() {
        if (sessionStorage.getItem("isSimmersionUser")) {
          return true;
        }
        else {
          return false;
        }
      }
    }
  }
</script>
